import React from 'react';
import Home from '../Home/Home';
import MeetingsAndCollections from '../MeetingsAndCollections/MeetingsAndCollections';
import Notifications from '../Notifications/Notifications';
import Favorites from '../Favorites';
import Icon from '@projeccions-pdc/react-icon';
import customizationStyle from '../../../themeCustomizationClasses';
import LocalizedStrings from '../../Localization/localization';
import UserSettingsModal from '../UserSettingsModal';
import PlatformChangerModal from '../PlatformChangerModal';
import NotificationsBadge from '../../Common/NotificationsBadge';
import PropTypes from 'prop-types';

const menuIconSize = '20px';
const iconPlaceholderHeight = '42px';
const iconPlaceholderHeightSmartphone = '54px';

const CustomBadgeWithStyle = (props) => {
    let iconProps = {
        name: 'fa-envelope-o',
        primaryColor: props.newMenu === true ? '#000' : '#fff',
        size: menuIconSize,
    };
    return (
        <div style={props.newMenu ? { padding: '10px' } : undefined}>
            <NotificationsBadge>
                <Icon {...iconProps} />
            </NotificationsBadge>
        </div>
    );
};
CustomBadgeWithStyle.propTypes = {
    newMenu: PropTypes.bool.isRequired,
};

const getNavigation = (smartphoneView, notify, isOnline, compact = false) => {
    let newMenu = false;
    if (smartphoneView === true) {
        newMenu = true;
    }

    if (compact !== true) {
        return [
            {
                id: 'search',
                name: LocalizedStrings.home,
                iconElement: (
                    <Icon
                        // name="fa-search"
                        name="md-home"
                        primaryColor={newMenu === true ? '#000' : '#fff'}
                        size={'24px'}
                        padding={newMenu ? 8 : undefined}
                    />
                ),
                reactComponent: Home,
                color: customizationStyle.charlyHomeColor,
            },
            {
                id: 'usersettings',
                name: LocalizedStrings.home,
                iconElement: (
                    <UserSettingsModal
                        notify={notify}
                        isOnline={isOnline}
                        fullWidth={true}
                        iconPlaceholderHeight={smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone}
                    >
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <div style={{ position: 'absolute', top: '-5px', right: '-5px' }}>
                                <Icon
                                    name="fa-cog"
                                    primaryColor={newMenu === true ? '#000' : '#fff'}
                                    padding={newMenu ? 10 : undefined}
                                    size={'10px'}
                                />
                            </div>
                            <Icon
                                name="fa-user"
                                primaryColor={newMenu === true ? '#000' : '#fff'}
                                padding={newMenu ? 10 : undefined}
                                size={menuIconSize}
                            />
                        </div>
                    </UserSettingsModal>
                ),
                reactComponent: undefined,
                color: customizationStyle.charlyHomeColor,
            },
            {
                id: 'favorites',
                name: LocalizedStrings.favorites,
                iconElement: (
                    <Icon
                        name="fa-star"
                        primaryColor={newMenu === true ? '#000' : '#fff'}
                        size={menuIconSize}
                        padding={newMenu ? 10 : undefined}
                    />
                ),
                reactComponent: Favorites,
                color: customizationStyle.charlyFavsColor,
            },
            {
                id: 'meet',
                name: LocalizedStrings.meet,
                iconElement: (
                    <Icon
                        name="fa-calendar"
                        primaryColor={newMenu === true ? '#000' : '#fff'}
                        size={menuIconSize}
                        padding={newMenu ? 10 : undefined}
                    />
                ),
                reactComponent: MeetingsAndCollections,
                color: customizationStyle.charlyMtgColColor,
            },
            {
                id: 'notifications',
                name: LocalizedStrings.notifications,
                iconElement: <CustomBadgeWithStyle newMenu={newMenu} />,
                reactComponent: Notifications,
                color: customizationStyle.charlyNotisColor,
            },
            {
                id: 'changeplatform',
                name: LocalizedStrings.tools,
                iconElement: (
                    <PlatformChangerModal
                        fullWidth={true}
                        iconPlaceholderHeight={smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone}
                    >
                        <Icon
                            name="fa-exchange"
                            primaryColor={newMenu === true ? '#000' : '#fff'}
                            size={menuIconSize}
                            padding={newMenu ? 10 : undefined}
                        />
                    </PlatformChangerModal>
                ),
                reactComponent: undefined, //Tools,
                color: customizationStyle.charlyToolsColor,
            },
        ];
    } else {
        newMenu = true;

        return [
            {
                id: 'search',
                name: LocalizedStrings.home,
                iconElement: (
                    <Icon
                        // name="fa-search"
                        name="fa-search"
                        primaryColor={newMenu === true ? '#000' : '#fff'}
                        size={'24px'}
                        padding={newMenu ? 8 : undefined}
                    />
                ),
                reactComponent: Home,
                color: customizationStyle.charlyHomeColor,
            },
            {
                id: 'usersettings',
                name: LocalizedStrings.home,
                iconElement: (
                    <UserSettingsModal
                        notify={notify}
                        isOnline={isOnline}
                        fullWidth={true}
                        iconPlaceholderHeight={smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone}
                    >
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                            <div style={{ position: 'absolute', top: '-5px', right: '-5px' }}>
                                <Icon
                                    name="fa-cog"
                                    primaryColor={newMenu === true ? '#000' : '#fff'}
                                    padding={newMenu ? 10 : undefined}
                                    size={'10px'}
                                />
                            </div>
                            <Icon
                                name="fa-user"
                                primaryColor={newMenu === true ? '#000' : '#fff'}
                                padding={newMenu ? 10 : undefined}
                                size={menuIconSize}
                            />
                        </div>
                    </UserSettingsModal>
                ),
                reactComponent: undefined,
                color: customizationStyle.charlyHomeColor,
            },
            {
                id: 'changeplatform',
                name: LocalizedStrings.tools,
                iconElement: (
                    <PlatformChangerModal
                        fullWidth={true}
                        iconPlaceholderHeight={smartphoneView !== true ? iconPlaceholderHeight : iconPlaceholderHeightSmartphone}
                    >
                        <Icon
                            name="fa-exchange"
                            primaryColor={newMenu === true ? '#000' : '#fff'}
                            size={menuIconSize}
                            padding={newMenu ? 10 : undefined}
                        />
                    </PlatformChangerModal>
                ),
                reactComponent: undefined, //Tools,
                color: customizationStyle.charlyToolsColor,
            },
        ];
    }
};

export default getNavigation;
